// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Header_navBar__1vvLQ","logo":"Header_logo__3_SJs index_videoGameTitles__2Or8-","navLinks":"Header_navLinks__hqVPe","loginLinks":"Header_loginLinks__VsWxD"};